import { useEffect, useState, useRef, useCallback } from 'react';

const KONAMI_SEQUENCE = [
  'ArrowUp', 'ArrowUp',
  'ArrowDown', 'ArrowDown',
  'ArrowLeft', 'ArrowRight',
  'ArrowLeft', 'ArrowRight',
  'b', 'a'
];

export function useKonamiCode(): boolean {
  const [ activated, setActivated ] = useState( false );
  const indexRef = useRef( 0 );

  const handleKeyDown = useCallback( ( e: KeyboardEvent ) => {
    if ( activated ) return;

    const key = e.key.length === 1 ? e.key.toLowerCase() : e.key;

    if ( key === KONAMI_SEQUENCE[ indexRef.current ] ) {
      indexRef.current++;
      if ( indexRef.current === KONAMI_SEQUENCE.length ) {
        setActivated( true );
        indexRef.current = 0;
      }
    } else {
      indexRef.current = 0;
      // Check if the failed key is the start of the sequence
      if ( key === KONAMI_SEQUENCE[ 0 ] ) {
        indexRef.current = 1;
      }
    }
  }, [ activated ] );

  useEffect( () => {
    window.addEventListener( 'keydown', handleKeyDown );
    return () => {
      window.removeEventListener( 'keydown', handleKeyDown );
    };
  }, [ handleKeyDown ] );

  return activated;
}
